/**
 * Enumeration of resource types for authorization.
 */
export enum ResourceEnum {
  None = 0,
  Rater = 1,
  Participant = 2,
  ClientAdmin = 3,
  Admin = 4,
  UserManager = 5,
}
